import {Component, ElementRef, HostListener, OnInit, OnDestroy, ViewChild} from '@angular/core';

import {LoginService} from 'app/login/login.service';
import {AccountService} from 'app/core/auth/account.service';
import {Account} from 'app/core/auth/account.model';
import {Router, RouterStateSnapshot} from "@angular/router";
import {JoyrideService} from 'ngx-joyride';
import {FormBuilder} from "@angular/forms";
import {ToolbarService} from "../services/toolbar.service";
import {Toolbar} from "../models/toolbar";
import {NavbarService} from "../services/navbar.service";
import {TributiService} from "../services/tributi.service";
import {MessageService} from "../services/message.service";
import {AmministrazioneService} from "../services/amministrazione.service";
import {SubscriptionManager} from "../shared/subscription-manager/subscription-manager.class";
import {AlertService} from "../shared/alert/alert.service";
import {StateStorageService} from "../core/auth/state-storage.service";
@Component({
  selector: 'jhi-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent extends SubscriptionManager implements OnInit, OnDestroy {

  @ViewChild('INPUT_SEARCH') _input_search!: ElementRef;
  @ViewChild('DIV_MODAL_OPENER') _div_modal_opener: ElementRef | undefined;

  result!: Toolbar[];
  allServ!: Array<{nmTitolo: string, nmComponent: string, flToolbar: boolean, codice?: string | undefined, macroArea: string, inEvidenza: boolean}>;
  allServNoFiltered!: Array<{nmTitolo: string, nmComponent: string, flToolbar: boolean, codice?: string | undefined, macroArea: string, inEvidenza: boolean}>;
  servInEvidenza!: Array<{nmTitolo: string, nmComponent: string, flToolbar: boolean, codice?: string | undefined, macroArea: string, inEvidenza: boolean}>;
  mouseOverModal = false;
  account: Account | null = null;
  actualRolePath: string;
  invertsvg: boolean;
  loading: boolean;
  toolbarServices: Toolbar[] = [];
  servicesStorage: Toolbar[] = [];
  minToShow = 0;
  maxToShow = 5;
  actualMinToShow: number;
  actualMaxToShow: number;
  mobile: boolean;
  showServiceNavBar: boolean;
  toolbarForm = this.fb.group({
    servizio: ['Tutti i servizi'],
    index: [-1],
  })
  numServiziTot = 0;
  protected readonly JSON = JSON;


  constructor(
    private amministrazioneService: AmministrazioneService,
    private accountService: AccountService,
    private tributiService: TributiService,
    private messageService: MessageService,
    private loginService: LoginService,
    public route: Router,
    private joyrideService: JoyrideService,
    private fb: FormBuilder,
    private apiService: ToolbarService,
    public navService: NavbarService,
    private alertService: AlertService,
    private stateStorageService: StateStorageService
  ) {
    super();
    this.actualRolePath = "";
    this.invertsvg = false;
    this.loading = false;
    this.actualMinToShow = 0;
    this.actualMaxToShow = 0;
    this.showServiceNavBar = false;
    this.mobile = false;
  }

  rimuoviQueryModal(): void {
    if (!this.mouseOverModal) {
      this._div_modal_opener?.nativeElement?.classList?.remove('show');
    }
  }

  apriQueryModal(): void {
    if (this._input_search.nativeElement?.value?.length > 1) {
      this._div_modal_opener?.nativeElement?.classList?.add('show');
    }
  }

  searchInputChange(event: any): void { // input cambiato

    if (event.target.value.length > 1) {
      if (this._input_search.nativeElement.value && this._input_search.nativeElement.value !== '') {

        this.subs.sink = this.amministrazioneService.querySearch(this._input_search.nativeElement.value).subscribe({
          next: (res) => {
            if (res !== undefined) {
              this.result = res;
            } else {
              this.result = []
            }
          },
          complete: () => this._div_modal_opener?.nativeElement?.classList?.add('show'),
          error: () => {
            this.result = [];
            this._div_modal_opener?.nativeElement?.classList?.remove('show');
          }
        })
      } else {
        this.result = [];
        this._div_modal_opener?.nativeElement?.classList?.remove('show');
      }
    } else {
      this.result = [];
      this._div_modal_opener?.nativeElement?.classList?.remove('show');
    }
  }

  getServizio(): string {
    return <string>this.toolbarForm.controls['servizio'].value;
  }

  getIndex(): number {
    return <number>this.toolbarForm.controls['index'].value;
  }

  formPatchValue(servizio: string, index: number): void {
    this.toolbarForm.patchValue({
      servizio,
      index
    });
    if(this.toolbarForm.controls['servizio'].value !== 'Cassetto del cittadino') {
      localStorage.setItem('servizioSelezionato', JSON.stringify(this.toolbarForm.value));
    }
    if(this.toolbarForm.controls['servizio'].value === 'Cassetto del cittadino'){
      void this.route.navigate(['Cruscotto/le-mie-attivita'], {state: {cambioVisuale: true}});
    }
  }

  ngOnInit(): void {
    if (localStorage.getItem('servizioSelezionato')) {
      this.formPatchValue(JSON.parse(<string>localStorage.getItem('servizioSelezionato')).servizio, JSON.parse(String(localStorage.getItem('servizioSelezionato'))).index)
    }
    this.subs.sink = this.accountService.identity().subscribe(account => (this.account = account));
    this.loading = true
    this.subs.sink = this.apiService.getToolbar().subscribe({
        next: (res) => {
          this.allServ = [];
          this.allServNoFiltered = [];
          this.toolbarServices = res;
          if (this.maxToShow < this.toolbarServices.length) {
            this.actualMaxToShow = this.toolbarServices.length / 2;
            this.maxToShow = this.toolbarServices.length / 2;
            for (let i = 0; i <= this.toolbarServices.length / 2; i++) {
              if (this.toolbarForm.get('servizio')?.value === this.toolbarServices[i].nmServizio) {
                this.invertsvg = false;
                break;
              } else {
                this.invertsvg = true
              }
            }
            if (this.invertsvg) {
              if (this.toolbarForm.get('index')?.value !== -1) {
                this.invertsvg = !this.invertsvg
                this.invertSVG();
              }
            }
          }
          if (this.toolbarForm.get('index')?.value === -1) {
            this.invertsvg = true;
            this.invertSVG();
          }
          this.toolbarServices.forEach((value) => {
            if (value.nmServizio !== 'Attività') {
              this.numServiziTot += value.numFunzioniServizio;
            }
          });
          this.setLocalStorage()
          this.getLocalStorage();
          this.toolbarServices.forEach((macro) => {
            macro.funzioniServizio.forEach((fnServ) => {
              (fnServ as any).macroArea = macro.nmServizio;
              if (fnServ.flToolbar) this.allServ.push(fnServ as any)
            })
          });
          this.allServNoFiltered = this.allServ.slice();
          this.allServ.sort((a, b) => a.nmTitolo?.localeCompare(b.nmTitolo));
          this.servInEvidenza = this.allServ.filter(s => { return s.inEvidenza});
          this.servicesStorage = this.servicesStorage.filter(serv => serv.nmServizio !== 'Attività');
          this.loading = false;
        }, error: () => {
          this.route.navigate(['error']).then();
        }
      }
    );
    this.subs.sink = this.messageService.attivita.subscribe({
      next: (att) => {
        this.formPatchValue(att, <number>this.toolbarForm.get('index')?.value)
      }
    })

    this.actualMinToShow = this.minToShow;
    this.actualMaxToShow = this.maxToShow;

    if (window.innerWidth <= 576) {
      this.mobile = true;
      this.showServiceNavBar = false;
      this.actualMaxToShow = this.servicesStorage.length;
    } else {
      this.showServiceNavBar = true;
    }

  }

  searchAllServ(event:any): void{
    this.allServ = this.allServNoFiltered.filter(s => {return s.nmTitolo.toLowerCase().includes(event.value.toLowerCase())});
    this.allServ.sort((a, b) => a.nmTitolo?.localeCompare(b.nmTitolo));
  }

  onTour(): void {
    if (!this.mobile && this.servicesStorage.length > 6) {
      this.joyrideService.startTour({
        steps: ['primoStepHome', 'secondoStepHome', 'terzoStepHome', 'quartoStepHome']
      })
    } else {
      this.joyrideService.startTour({
        steps: ['primoStepHome', 'terzoStepHome', 'quartoStepHome']
      })
    }
  }

  setLocalStorage(): void {
    localStorage.removeItem('servicesStorage');
    this.servicesStorage = this.servicesStorage.filter(serv => serv.nmServizio !== 'Attività');
    localStorage.setItem('servicesStorage', JSON.stringify(this.toolbarServices));
  }

  getLocalStorage(): Toolbar[] {
    this.servicesStorage = JSON.parse(localStorage.getItem('servicesStorage') ?? '{}');
    this.servicesStorage = this.servicesStorage.filter((s) => s.nmServizio !== 'Attività');
    return this.servicesStorage;
  }

  login(): void {
    this.loginService.login();
    void this.route.navigate(['admin/bacheca']);
  }

  invertSVG(): void {
    this.invertsvg = !this.invertsvg;
    if (!this.invertsvg) {
      this.actualMinToShow = this.minToShow;
      this.actualMaxToShow = this.maxToShow;
    } else {
      this.actualMinToShow = this.maxToShow;
      this.actualMaxToShow = this.maxToShow * 2;
    }
  }

  @HostListener('window:resize')
  onResize(): void {
    if (window.innerWidth <= 576) {
      this.mobile = true;
      this.showServiceNavBar = false;
      this.actualMaxToShow = this.servicesStorage.length;
    } else {
      this.mobile = false;
      this.showServiceNavBar = true;
      this.actualMaxToShow = this.maxToShow;
    }
  }

  openServiceNavbar(): void {
    this.showServiceNavBar = !this.showServiceNavBar;
  }

  routing(component: any): void {
    if(this.navService.navRouting.has(component)){
      if (this.account?.id != null) {
        localStorage.setItem('servizioSelezionato', JSON.stringify(this.toolbarForm.value));
        void this.route.navigate([this.navService.navRouting.get(component)]);
      } else {
        console.error(component);
        if(component !== 'PrenotaNuovoAppuntamentoComponent'){
          this.loginService.login();
        }
        else{
          void this.route.navigate([this.navService.navRouting.get(component)]);
        }
      }
    }else{
      if(this.navService.redirectRouting.has(component)){
        window.open(<string>this.navService.redirectRouting.get(component), "_blank");
      }
    }
  }

  ngOnDestroy() {
    document.getElementById('#splide')?.remove();
  }

  routingTributi(component: any, funzione: {
    nmTitolo: string;
    nmComponent: string;
    flToolbar: boolean;
    codice?: string
  }): void {
    if (this.account?.id != null) {
      this.loading = true;
      localStorage.removeItem('pagamentoJsonForm');
      localStorage.removeItem('pagamentoJsonFormMultiplo');
      localStorage.setItem('servizioSelezionato', JSON.stringify(this.toolbarForm.value));
      this.route.navigate([component], { queryParams: { servizio: funzione.codice } }).then();
     } else {
      this.loginService.redirectUrl = (this.route.createUrlTree([component], { queryParams: { servizio: funzione.codice } }).toString());
      this.stateStorageService.storeUrl(this.loginService.redirectUrl)
      this.loginService.login();
    }
  }
}
